import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.VUE_APP_SUPABASE_URL || 'https://wmknzfufmicidspkwazr.supabase.co'
const supabaseKey = process.env.VUE_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Indta256ZnVmbWljaWRzcGt3YXpyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk1MTU1MTgsImV4cCI6MjA4NTA5MTUxOH0.X8Gwh_mURIeCKPCBrixu15QZVZ44MlGV3093ZsMDk1A'

export const supabase = createClient(supabaseUrl, supabaseKey)
